import { type RefObject } from 'react';
import gsap from 'gsap';
import { Flip } from 'gsap/Flip';
import { useGSAP } from '@gsap/react';
import { shouldAnimate } from '../lib/format';

gsap.registerPlugin(useGSAP, Flip);
gsap.defaults({ ease: 'power3.out', duration: 0.6 });

export { gsap, Flip, useGSAP };

/**
 * Staggered entrance for every `[data-anim]` element inside `scope`.
 * Transform/opacity only, so it never triggers layout and never competes with video decode.
 */
export function useEnter(scope: RefObject<HTMLElement | null>, deps: unknown[] = []) {
  useGSAP(
    () => {
      if (document.visibilityState !== 'visible') return;
      const mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap.from('[data-anim]', { y: 18, opacity: 0, stagger: 0.05, duration: 0.55, clearProps: 'transform,opacity' });
      });
      return () => mm.revert();
    },
    { scope, dependencies: deps },
  );
}

/** One-shot "pulse" ring used when someone else presses play/pause. */
export function pulse(el: Element | null) {
  if (!el || !shouldAnimate()) return;
  gsap.fromTo(el, { scale: 1, opacity: 0.9 }, { scale: 2.4, opacity: 0, duration: 0.9, ease: 'power2.out' });
}
